import { Link } from 'react-router-dom';
import type { Category, Listing } from '../types';

interface Props {
  categories: Category[];
  listings: Listing[];
}

export default function CategorySlider({ categories, listings }: Props) {
  return (
    <div className="relative">
      <div className="category-slider-shell">
        <div
          className="category-slider"
          aria-label="MarineLink categories"
        >
          {categories.map((category) => {
            const count = listings.filter((listing) => listing.category_id === category.id).length;

            return (
              <Link
                key={category.id}
                to={`/browse?category=${category.id}`}
                className="category-slide-card group"
              >
                <span className="absolute inset-x-0 top-0 h-[3px] bg-accent opacity-0 transition-opacity group-hover:opacity-100" />
                <span className="category-slide-icon" aria-hidden="true">
                  {category.icon}
                </span>
                <span className="category-slide-name">
                  {category.name}
                </span>
                <span className="category-slide-count">
                  {count} {count === 1 ? 'listing' : 'listings'}
                </span>
              </Link>
            );
          })}
        </div>
      </div>
    </div>
  );
}
